import { logos } from 'common'
import styled, { css } from 'styled-components'

const designerCSS = css`
  background: url(${logos.powered_by_yolorekt_white}) center center / 130px auto no-repeat;
  width: 130px;
  margin: 2px 0 0 15px;
  height: 100%;
  display: block;

  @media (max-width: 1600px) {
    width: 160px;
  }

  @media (max-width: 800px) {
    background: url(${logos.yolorekt_moon_white}) center center / 35px auto no-repeat;
    width: 35px;
    margin: 2px 0 0 20px;
    height: 100%;
    display: block;
  }
`

export const PoweredByYolorektLogo = styled.a`
  ${designerCSS}
`
